import {
  FlexColumn,
  ModelSelect,
} from '@equifinance/shared';
import styled from 'styled-components';
import {
  Label, SelectWrapper, UnderwriterDecisionTitle,
} from '../../../../components/UnderwriterDecision';
import { OS1OS3Decision } from '../../../../../../contexts/checklist';

const UnderwriterDecisionHeader = styled(UnderwriterDecisionTitle)`${({ theme }) => `
  border-radius: ${theme.borderRadius[2]} ${theme.borderRadius[2]} 0 0;
`}`;

export default function OS1OS3UnderwriterDecision() {
  return (
    <FlexColumn>
      <UnderwriterDecisionHeader>
        <Label>{'Underwriter\'s decision'}</Label>
        <SelectWrapper>
          <SelectWrapper>
            <ModelSelect
              placeholder="Please select"
              field="os1os3.decision"
              options={{ [OS1OS3Decision.Completed]: OS1OS3Decision.Completed }}
            />
          </SelectWrapper>
        </SelectWrapper>
      </UnderwriterDecisionHeader>
    </FlexColumn>
  );
}
